/* Le Buisson – thème Shopify · theme.js */
(() => {
  const d = document, R = d.documentElement;
  R.classList.remove('no-js');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = window.LB_STRINGS || {};
  const routes = window.LB_ROUTES || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart', root: '/' };

  /* ---------- Scroll progress ---------- */
  const bar = d.getElementById('lb-bar');
  if (bar) addEventListener('scroll', () => {
    const m = R.scrollHeight - innerHeight;
    bar.style.width = (m > 0 ? scrollY / m * 100 : 0) + '%';
  }, { passive: true });

  /* ---------- Reveal ---------- */
  const reveal = root => {
    const els = (root || d).querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .15 });
    els.forEach((e, i) => { e.style.transitionDelay = (i % 5) * 90 + 'ms'; io.observe(e); });
  };

  /* ---------- Tilt ---------- */
  const tilt = root => {
    if (reduced || matchMedia('(hover: none)').matches) return;
    (root || d).querySelectorAll('[data-tilt]:not([data-tilt-on])').forEach(e => {
      e.dataset.tiltOn = '1';
      e.addEventListener('pointermove', v => {
        const b = e.getBoundingClientRect(), x = (v.clientX - b.left) / b.width - .5, y = (v.clientY - b.top) / b.height - .5;
        e.style.transform = `perspective(900px) rotateY(${x * 12}deg) rotateX(${-y * 12}deg)`;
        e.style.setProperty('--gx', (x + .5) * 100 + '%'); e.style.setProperty('--gy', (y + .5) * 100 + '%');
      });
      e.addEventListener('pointerleave', () => { e.style.transform = ''; });
    });
  };

  /* ---------- Hero particles (canvas 2D, sans dépendance) ---------- */
  const particles = root => {
    (root || d).querySelectorAll('canvas.hero-particles:not([data-on])').forEach(c => {
      c.dataset.on = '1';
      if (reduced) return;
      const ctx = c.getContext('2d'), N = 140, P = [];
      let w = 0, h = 0, mx = 0, my = 0, dpr = Math.min(devicePixelRatio || 1, 2), visible = true;
      const size = () => { w = c.clientWidth; h = c.clientHeight; c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      size(); addEventListener('resize', size);
      for (let i = 0; i < N; i++) P.push({ x: Math.random(), y: Math.random(), z: .3 + Math.random() * .7, s: .4 + Math.random() * 1.6 });
      addEventListener('pointermove', e => { mx = e.clientX / innerWidth - .5; my = e.clientY / innerHeight - .5; }, { passive: true });
      new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(c);
      (function loop() {
        if (visible) {
          ctx.clearRect(0, 0, w, h);
          for (const p of P) {
            p.y -= .0006 * p.z; if (p.y < -.02) { p.y = 1.02; p.x = Math.random(); }
            const x = (p.x + mx * .04 * p.z) * w, y = (p.y + my * .03 * p.z) * h;
            ctx.globalAlpha = .35 + .5 * p.z; ctx.fillStyle = '#d9b456';
            ctx.beginPath(); ctx.arc(x, y, p.s * p.z, 0, 6.283); ctx.fill();
          }
        }
        requestAnimationFrame(loop);
      })();
    });
  };

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  const toast = msg => {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 3500);
  };

  /* ---------- Mobile menu ---------- */
  d.addEventListener('click', e => {
    const open = e.target.closest('[data-menu-open]'), close = e.target.closest('[data-menu-close]');
    const nav = d.getElementById('mobile-nav');
    if (!nav) return;
    if (open) { nav.classList.add('is-open'); open.setAttribute('aria-expanded', 'true'); d.body.style.overflow = 'hidden'; nav.querySelector('a,button')?.focus(); }
    if (close || (nav.classList.contains('is-open') && e.target.closest('#mobile-nav a'))) { nav.classList.remove('is-open'); d.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false'); d.body.style.overflow = ''; }
  });

  /* ---------- Localization (langue / pays) ---------- */
  d.addEventListener('change', e => {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Cart drawer ---------- */
  const drawerId = 'cart-drawer';
  const drawer = () => d.getElementById('CartDrawer');
  const useDrawer = () => !!drawer() && R.dataset.cartType === 'drawer';
  let lastFocus = null;

  const openDrawer = () => {
    const dr = drawer(); if (!dr) return;
    lastFocus = d.activeElement;
    dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden';
    setTimeout(() => dr.querySelector('.drawer__panel')?.focus(), 50);
  };
  const closeDrawer = () => {
    const dr = drawer(); if (!dr) return;
    dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); d.body.style.overflow = '';
    lastFocus?.focus?.();
  };

  const updateCount = count => {
    d.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count > 0 ? count : ''; el.dataset.count = count; });
  };

  const renderSections = sections => {
    if (!sections) return;
    const html = sections[drawerId];
    if (html) {
      const tmp = new DOMParser().parseFromString(html, 'text/html');
      const fresh = tmp.querySelector('[data-drawer-inner]');
      const cur = d.querySelector('#CartDrawer [data-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      const c = tmp.querySelector('[data-cart-total-count]');
      if (c) updateCount(+c.dataset.cartTotalCount);
    }
  };

  const fetchDrawer = async () => {
    const r = await fetch(`${routes.root.replace(/\/$/, '')}/?sections=${drawerId}`, { headers: { Accept: 'application/json' } });
    renderSections(await r.json());
  };

  const busy = on => drawer()?.classList.toggle('is-busy', on);

  const changeLine = async (key, quantity) => {
    busy(true);
    try {
      const r = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: drawerId, sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok) { toast(j.description || j.message || T.error); await fetchDrawer(); return; }
      renderSections(j.sections);
      if (d.body.dataset.template === 'cart') location.reload();
    } catch (e) { toast(T.error); } finally { busy(false); }
  };

  d.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]') && useDrawer()) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    const rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('#CartDrawer')) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      const input = step.closest('.qty').querySelector('input');
      const min = +input.min || 0, max = input.max ? +input.max : Infinity;
      const v = Math.min(max, Math.max(min, (+input.value || 0) + (+step.dataset.qtyStep)));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  d.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); d.querySelector('[data-menu-close]')?.click(); } });

  let qtyTimer;
  d.addEventListener('change', e => {
    const inp = e.target.closest('#CartDrawer input[data-line-key]');
    if (inp) { clearTimeout(qtyTimer); qtyTimer = setTimeout(() => changeLine(inp.dataset.lineKey, Math.max(0, +inp.value || 0)), 250); }
    const note = e.target.closest('#CartDrawer textarea[name="note"]');
    if (note) fetch(`${routes.cart_update_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  d.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !useDrawer()) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn?.classList.add('is-loading'); btn?.setAttribute('aria-disabled', 'true');
    try {
      const fd = new FormData(form);
      fd.append('sections', drawerId);
      fd.append('sections_url', location.pathname);
      const r = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const j = await r.json();
      if (!r.ok || j.status) {
        const msg = j.description || j.message || T.error;
        if (err) { err.textContent = msg; err.hidden = false; } else toast(msg);
        return;
      }
      renderSections(j.sections);
      openDrawer();
    } catch (x) { toast(T.error); }
    finally { btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-disabled'); }
  });

  /* ---------- Variant picker ---------- */
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2), [i, dec] = v.split('.');
    const withSep = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const f = fmt || window.LB_MONEY || '{{amount_with_comma_separator}} €';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_with_comma_separator') return withSep(i, '.') + ',' + dec;
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(String(Math.round(cents / 100)), '.');
      if (k === 'amount_no_decimals') return withSep(String(Math.round(cents / 100)), ',');
      if (k === 'amount_with_space_separator') return withSep(i, ' ') + ',' + dec;
      return withSep(i, ',') + '.' + dec;
    });
  };

  const initVariantPickers = root => {
    (root || d).querySelectorAll('[data-variant-picker]:not([data-on])').forEach(picker => {
      picker.dataset.on = '1';
      const scope = picker.closest('[data-product-scope]');
      const variants = JSON.parse(scope.querySelector('[data-variants-json]').textContent);
      const idInput = scope.querySelector('input[name="id"]');
      const btn = scope.querySelector('[data-add-btn]');
      const priceEl = scope.querySelector('[data-price]');
      const update = () => {
        const sel = [...picker.querySelectorAll('fieldset')].map(f => f.querySelector('input:checked')?.value);
        const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
        // marquer les valeurs indisponibles
        picker.querySelectorAll('fieldset').forEach((f, idx) => {
          f.querySelectorAll('input').forEach(inp => {
            const ok = variants.some(v => v.available && v.options[idx] === inp.value && v.options.every((o, i) => i === idx || o === sel[i]));
            inp.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) { btn.disabled = true; btn.textContent = T.unavailable; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? T.add_to_cart : T.sold_out;
        if (priceEl) {
          let h = `<span>${money(v.price)}</span>`;
          if (v.compare_at_price > v.price) h += `<span class="price__was">${money(v.compare_at_price)}</span>`;
          priceEl.querySelector('[data-price-main]').innerHTML = h;
          const save = scope.querySelector('[data-save]');
          if (save) { const s = v.compare_at_price - v.price; save.hidden = !(s > 0); save.textContent = (T.you_save || '').replace('[amount]', money(s)); }
        }
        if (v.featured_media) {
          const t = scope.querySelector(`[data-media-id="${v.featured_media.id}"]`);
          t?.click();
        }
        if (picker.dataset.updateUrl === 'true') history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
        const pc = scope.querySelector('.shopify-payment-button'); if (pc) pc.style.display = v.available ? '' : 'none';
      };
      picker.addEventListener('change', update);
      update();
    });
  };

  /* ---------- Product gallery ---------- */
  d.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const g = t.closest('[data-gallery]'), main = g.querySelector('[data-gallery-main] img');
    main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
    g.querySelectorAll('[data-thumb]').forEach(b => b.setAttribute('aria-current', b === t ? 'true' : 'false'));
  });

  /* ---------- Product recommendations ---------- */
  const recos = root => {
    (root || d).querySelectorAll('[data-recos-url]:not([data-on])').forEach(async el => {
      el.dataset.on = '1';
      try {
        const r = await fetch(el.dataset.recosUrl); const t = await r.text();
        const n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recos-url]');
        if (n && n.querySelector('.card')) { el.innerHTML = n.innerHTML; reveal(el); tilt(el); }
        else el.closest('section')?.remove();
      } catch (x) { }
    });
  };

  /* ---------- Pays par défaut des formulaires d'adresse ---------- */
  const countries = root => (root || d).querySelectorAll('select[data-default]').forEach(s => { if (s.dataset.default) s.value = s.dataset.default; });

  const init = root => { countries(root); reveal(root); tilt(root); particles(root); initVariantPickers(root); recos(root); };
  init();

  /* Éditeur de thème : réinitialiser les sections modifiées */
  d.addEventListener('shopify:section:load', e => init(e.target));
})();
